export default __webpack_public_path__ + "static/media/download.d1eb5c43.png";